import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ERROR_MESSAGES } from '../constant/error-messages.constant';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerUtil {
  private readonly translateService = inject(TranslateService);
  private readonly messageService = inject(MessageService);

  public getErrorMessage(error: unknown, fallbackKey: string): string {
    return error instanceof Error
      ? error.message
      : this.translateService.instant(fallbackKey);
  }

  public getTranslatedMessage(key: string): string {
    return this.translateService.instant(key);
  }

  public showTranslatedError(
    messageKey: string,
    titleKey: string = ERROR_MESSAGES.PURCHASE.PURCHASE_ERROR
  ): void {
    this.messageService.add({
      severity: 'error',
      summary: this.translateService.instant(titleKey),
      detail: this.translateService.instant(messageKey),
    });
  }
}
